import SharedContainer from 'shared/presentation/contexts';
import { sharedLocale } from 'shared/presentation/locale';

const sharedModule = {
  Container: SharedContainer,
  locale: sharedLocale,
};

export default sharedModule;
